// extracted by mini-css-extract-plugin
module.exports = {"content_lt":"style_content_lt__2uDy2","prix":"style_prix__22AAL","btn_ach":"style_btn_ach__3iUz9","btn_vant":"style_btn_vant__1kri8","s_title":"style_s_title__1ZR-s"};